import { RouteObject } from 'react-router-dom';
import FactoringRoutes from '@/user/routes/factoring/factoring.routes.tsx';
import '@/user/services/i18next/i18next.service.tsx';

const ClientRoutes: RouteObject = {
  lazy: () => import('@/user/layouts/default/default.layout.tsx'),
  children: [FactoringRoutes],
};
export default ClientRoutes;
